const PRODUCTION_API = 'https://mphoto.up.railway.app/api';
const PRODUCTION_SOCKET = 'https://mphoto.up.railway.app';
const LOCAL_API = 'http://localhost:5000/api';
const LOCAL_SOCKET = 'http://localhost:5000';

/** Hostname kiểu LAN / Tailscale — gọi backend cùng máy, port 5000. */
function isLanHost(host: string): boolean {
  if (host === 'localhost' || host === '127.0.0.1') return false;
  if (/^192\.168\.\d{1,3}\.\d{1,3}$/.test(host)) return true;
  if (/^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(host)) return true;
  if (/^172\.(1[6-9]|2\d|3[0-1])\.\d{1,3}\.\d{1,3}$/.test(host)) return true;
  // Tailscale / CGNAT-ish (vd. 100.x)
  if (/^100\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(host)) return true;
  return false;
}

/**
 * Local / LAN: ưu tiên backend trên cùng host.
 * - localhost → localhost:5000
 * - 192.168.x.x (máy khác mở UI) → cùng IP:5000 (không dùng localhost của máy kia)
 * Production / Railway: env hoặc URL Railway.
 */
function resolveApiUrls(): { api: string; socket: string } {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') {
      return { api: LOCAL_API, socket: LOCAL_SOCKET };
    }
    if (host === 'mphoto.up.railway.app' || host === 'm-photo-pro.up.railway.app') {
      return { api: PRODUCTION_API, socket: PRODUCTION_SOCKET };
    }
    if (isLanHost(host)) {
      return {
        api: `http://${host}:5000/api`,
        socket: `http://${host}:5000`,
      };
    }
  }

  if (process.env.NODE_ENV === 'development') {
    return {
      api: process.env.REACT_APP_API_URL || LOCAL_API,
      socket: process.env.REACT_APP_SOCKET_URL || LOCAL_SOCKET,
    };
  }

  return {
    api: process.env.REACT_APP_API_URL || PRODUCTION_API,
    socket: process.env.REACT_APP_SOCKET_URL || PRODUCTION_SOCKET,
  };
}

const resolved = resolveApiUrls();

export const API_URL = resolved.api;
export const SOCKET_URL = resolved.socket;

function resolvePublicAppOrigin(): string {
  const explicit = process.env.REACT_APP_PUBLIC_ORIGIN?.trim();
  if (explicit) return explicit.replace(/\/$/, '');
  return API_URL.replace(/\/api\/?$/i, '');
}

export const PUBLIC_APP_ORIGIN = resolvePublicAppOrigin();

/** HTML mobile upload nằm trên server cổng 5000, cùng host trang đang mở. */
export function currentAppOrigin(): string {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1' || isLanHost(host)) {
      return `http://${host}:5000`;
    }
  }
  return API_URL.replace(/\/api\/?$/i, '');
}

if (typeof window !== 'undefined') {
  console.log('API URL:', API_URL);
  console.log('Socket URL:', SOCKET_URL);
}
